export const isStagedUploadEnabled = () => process.env.REACT_APP_USE_STAGED_UPLOAD === 'true';

/**
 * @leapeasy/ui-kit DocumentUpload file rows: filename fills the row to the delete
 * button, then ellipsis (…) at the edge. Hides the kit's flex spacer between text and delete.
 */
export const documentUploadFileListSx = {
  width: '100%',
  '& > div > div:last-of-type > div': {
    minWidth: 0,
    width: '100%',
    overflow: 'hidden',
  },
  '& > div > div:last-of-type > div > div:first-of-type': {
    flexShrink: 0,
  },
  // Hide ui-kit Gap (flex-grow spacer) so the name can run to the delete control
  '& > div > div:last-of-type > div > div:nth-of-type(3)': {
    display: 'none',
  },
  '& > div > div:last-of-type > div > div:nth-of-type(2)': {
    flex: '1 1 0',
    minWidth: 0,
    maxWidth: '100%',
    overflow: 'hidden',
    paddingRight: '8px',
  },
  '& > div > div:last-of-type > div > div:nth-of-type(2) > *:first-child': {
    display: 'block',
    width: '100%',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  '& > div > div:last-of-type > div > div:last-of-type': {
    flexShrink: 0,
    marginLeft: 'auto',
  },
};

export const toDisplayFile = (stagedDoc) => ({
  id: stagedDoc.id,
  path: stagedDoc.originalFilename,
  name: stagedDoc.originalFilename,
  originalFilename: stagedDoc.originalFilename,
  size: Number(stagedDoc.sizeBytes ?? stagedDoc.size ?? 0),
  category: stagedDoc.category,
  status: stagedDoc.status,
});

export const getFileKey = (file) => {
  if (file?.id) {
    return `id:${file.id}`;
  }
  const name = file?.path || file?.name || file?.originalFilename;
  const size = file?.size ?? '';
  const lastModified = file?.lastModified ?? '';
  return `file:${name}:${size}:${lastModified}`;
};

export const getFileDisplayName = (file) =>
  file?.path || file?.originalFilename || file?.name || 'Document';

/** Form 7 review step: long filenames truncate with ellipsis inside flex cards */
export const reviewDocumentCategorySx = {
  minWidth: 0,
  width: '100%',
  maxWidth: '100%',
  overflow: 'hidden',
};

export const reviewDocumentFileNameStyle = {
  display: 'block',
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};
